import { format as formatDate, isSameDay, isValid } from 'date-fns'
import { formatInTimeZone } from 'date-fns-tz'

import i18n from '@/i18n'

export const formatDateTime = (dateTimeValue, timezone) => {
  if (!dateTimeValue) return { date: '-', time: '-' }

  const date =
    typeof dateTimeValue === 'number' ? new Date(Number(dateTimeValue)) : new Date(dateTimeValue)

  if (!isValid(date)) return { date: '-', time: '-' }

  if (timezone) {
    return {
      date: formatInTimeZone(date, timezone, 'MM/dd/yyyy'),
      time: formatInTimeZone(date, timezone, 'hh:mm a'),
    }
  }

  return {
    date: formatDate(date, 'MM/dd/yyyy'),
    time: formatDate(date, 'hh:mm a'),
  }
}

export const formatPermissions = (visitor, timezone) => {
  if (!visitor.mode) return '-'

  const mode = visitor.mode.toLowerCase()

  switch (mode) {
    case 'custom':
      if (visitor.startTime && visitor.endTime) {
        const startDate = new Date(visitor.startTime)
        const endDate = new Date(visitor.endTime)

        if (!isValid(startDate) || !isValid(endDate)) return '-'

        if (isSameDay(startDate, endDate)) {
          return timezone
            ? formatInTimeZone(startDate, timezone, 'MM/dd/yyyy')
            : formatDate(startDate, 'MM/dd/yyyy')
        }

        if (timezone) {
          return `${formatInTimeZone(startDate, timezone, 'MM/dd/yyyy')} - ${formatInTimeZone(
            endDate,
            timezone,
            'MM/dd/yyyy',
          )}`
        }
        return `${formatDate(startDate, 'MM/dd/yyyy')} - ${formatDate(endDate, 'MM/dd/yyyy')}`
      }
      if (visitor.startTime) {
        const date = new Date(visitor.startTime)

        if (!isValid(date)) return '-'

        return timezone
          ? formatInTimeZone(date, timezone, 'MM/dd/yyyy')
          : formatDate(date, 'MM/dd/yyyy')
      }
      return i18n.t('visitors:permissions.oneTimeVisit')

    case 'daily':
      return i18n.t('visitors:permissions.daily')

    case 'monthly':
      return visitor.monthlyPermission || i18n.t('visitors:permissions.monthly')

    case 'weekly':
      let days = []
      if (visitor.periodicity) {
        if (Array.isArray(visitor.periodicity)) {
          if (visitor.periodicity.length === 0) {
            return i18n.t('visitors:permissions.weekly')
          } else if (
            visitor.periodicity.length === 1 &&
            typeof visitor.periodicity[0] === 'string'
          ) {
            days = visitor.periodicity[0].split(',').map((d) => Number(d.trim()))
          } else {
            days = visitor.periodicity.map(Number)
          }
        } else if (typeof visitor.periodicity === 'string' && visitor.periodicity !== '') {
          days = visitor.periodicity.split(',').map((d) => Number(d.trim()))
        }
      }
      if (days.length > 0 && days.every((d) => !isNaN(d))) {
        const dayNames = [
          i18n.t('visitors:days.sun'),
          i18n.t('visitors:days.mon'),
          i18n.t('visitors:days.tue'),
          i18n.t('visitors:days.wed'),
          i18n.t('visitors:days.thu'),
          i18n.t('visitors:days.fri'),
          i18n.t('visitors:days.sat'),
        ]
        const daysString = days.map((day) => dayNames[day]).join(', ')
        return daysString
      }
      return i18n.t('visitors:permissions.weekly')

    default:
      return mode.charAt(0).toUpperCase() + mode.slice(1)
  }
}

export const emptyOptionText = '---'

// Note: staging returns { data, total } (EL-11863), production still returns the legacy
// { guests | vendors, count }. Accept both until the backend change ships to production.
export const readListEnvelope = (res) => {
  const body = res?.data ?? {}
  const items = [body.data, body.guests, body.vendors].find(Array.isArray) ?? []

  return { items, total: body.total ?? body.count ?? 0 }
}
